import styled, { css } from 'styled-components';

export const LogoHeaderGrey = styled.img`
  height: 30px;
  width: 90px;
  margin: auto 15px;
`;

export const Sidebar = styled.div<any>`
  ${({ isOpen, width = '251px' }) => css`
    position: fixed;
    width: ${isOpen ? width : '0'};
    top: 0;
    left: 0;
    height: 100%;
    background-color: #d9d9d9;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: width 0.3s ease;
    overflow-x: hidden;
  `}
`;

export const SidebarHeader = styled.header<any>`
  ${() => css`
    height: 43px;
    display: flex;
    align-items: center;
  `}
`;

export const SidebarContainer = styled.div<any>`
  ${({ width = '251px' }) => css`
    min-width: ${width};
    top: 0;
    left: 0;
  `}
`;

export const SidebarList = styled.ul<any>`
  ${() => css`
    white-space: nowrap;
    overflow: hidden;
    list-style: none;
    margin: 0;
    padding: 0;
  `}
`;

export const SidebarListItem = styled.li<any>`
  ${({ isSelected = false }) => css`
    padding: 12px 5px 12px 15px;
    cursor: pointer;
    font-weight: 500;
    background-color: ${isSelected ? '#b7b7b7' : 'transparent'};
    &:hover {
      background-color: #b7b7b7;
    }
  `}
`;

export const Main = styled.div<any>`
  ${({ isOpen, width = '251px' }) => css`
    margin-left: ${isOpen ? width : '0'};
    transition: margin-left 0.3s ease;
  `}
`;

export const TealBar = styled.div`
  display: flex;
  background-color: #d9d9d9;
`;

export const Button = styled.button`
  display: flex;
  background-color: transparent;
  color: #364856;
  font-size: 24px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  margin: auto 5px;
  &:hover {
    background-color: #b7b7b7;
  }
`;
